import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { PermissionApi } from 'api';

function useGetAll() {
  return useAuthQuery(getQueryKeys([KEY]).all, () => PermissionApi.getAll(), {
    select: (data) => data.data,
    staleTime: 1000 * 60 * 10, // 10m — 카탈로그는 자주 안 변함
  });
}

export default useGetAll;
